module.exports = "<mat-form-field class=\"w-100\">\n    <input matInput readonly [ngModel]=\"display\" ngDefaultControl [placeholder]=\"placeholder\">\n    <mat-icon class=\"clickable\" (click)=\"removeUser()\" *ngIf=\"canRemove()\" matSuffix>close</mat-icon>\n    <mat-icon class=\"clickable\" (click)=\"selectUser()\" matSuffix>arrow_drop_down</mat-icon>\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/select-user/select/select.component.html
// module id = ./src/app/shared/select-user/select/select.component.html
// module chunks = main